// extracted by mini-css-extract-plugin
export default {"container":"W9-z","productName":"X9-z","price":"Y9-z","dimensions":"Z9-z"};